import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import logo from "@/assets/logo.jpg";
import { COMPANY } from "@/data/site";

const Block = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-glass mb-4">{title}</h2>
    <div className="text-white/70 font-light leading-relaxed space-y-1">{children}</div>
  </div>
);

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#030712] text-white" data-testid="impressum-page">
      <header className="glass-strong border-b border-white/10">
        <div className="mx-auto max-w-4xl px-6 md:px-10 h-20 flex items-center gap-4">
          <Link to="/" data-testid="impressum-back" className="flex h-10 w-10 items-center justify-center rounded-sm border border-white/10 hover:border-cyan-glass hover:text-cyan-glass transition-colors">
            <ArrowLeft className="h-4 w-4" />
          </Link>
          <div className="flex items-center gap-3">
            <img src={logo} alt="S&P Reinigungsservice" className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20" />
            <span className="font-heading text-lg font-semibold tracking-tight">S&amp;P Reinigungsservice</span>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 md:px-10 py-16 md:py-24">
        <h1 className="font-heading text-5xl md:text-7xl font-semibold tracking-tighter mb-4">Impressum</h1>
        <p className="text-white/50 font-light mb-16">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</p>

        <Block title="Anbieter">
          <p className="text-white">{COMPANY.name}</p>
          <p>{COMPANY.street}</p>
          <p>{COMPANY.zip}</p>
          <p>Deutschland</p>
        </Block>

        <Block title="Kontakt">
          <p>Telefon: <a href={`tel:${COMPANY.phoneRaw}`} className="text-white hover:text-cyan-glass transition-colors">{COMPANY.phone}</a></p>
          <p>E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-white hover:text-cyan-glass transition-colors break-all">{COMPANY.email}</a></p>
        </Block>

        <Block title="Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)">
          <p>Inhaber des {COMPANY.name}</p>
          <p>{COMPANY.street}, {COMPANY.zip}</p>
        </Block>

        <Block title="Umsatzsteuer">
          <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG:</p>
          <p className="text-white">DE451949165</p>
        </Block>

        <Block title="Betriebshaftpflichtversicherung">
          <p>Versicherer: <span className="text-white">LVM Versicherung, Münster</span></p>
          <p>Räumlicher Geltungsbereich: Deutschland</p>
        </Block>

        <Block title="Streitschlichtung">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            {" "}<a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-cyan-glass hover:underline">https://ec.europa.eu/consumers/odr</a>.
          </p>
          <p className="mt-2">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Block>

        <Block title="Haftung für Inhalte">
          <p>
            Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
            Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte
            fremde Informationen zu überwachen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung
            von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          </p>
        </Block>

        <Block title="Urheberrecht">
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
            deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Downloads und Kopien
            dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
        </Block>

        <p className="text-white/30 text-sm font-mono mt-16 pt-8 border-t border-white/10">
          Diese Angaben ersetzen keine Rechtsberatung.
        </p>
      </main>
    </div>
  );
}
